import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILanguageState } from '../components/apia/common/modals/translateModal/LanguagesList';
import { TModify } from '../types';

interface ITranslationState {
  langs: ILanguageState[];
  selectedLanguage:
    | {
        id: string;
        label: string;
      }
    | undefined
    | null;
}

type TTranslationSlice = Record<string, ITranslationState>;

const translationSlice = createSlice({
  name: 'translationSlice',
  initialState: {} as TTranslationSlice,

  reducers: {
    setState(
      state,
      {
        payload: { id, ...rest },
      }: PayloadAction<TModify<Partial<ITranslationState>, { id: string }>>,
    ) {
      state[id] = { ...state[id], ...rest };
    },
    markAsQueried(
      state,
      {
        payload: { id, langId, hasQueriedServer },
      }: PayloadAction<{
        id: string;
        langId: string;
        hasQueriedServer: boolean;
      }>,
    ) {
      state[id].langs = state[id].langs.map((current) => {
        if (String(current.id) === String(langId))
          return { ...current, hasQueriedServer };
        return current;
      });
    },
    markIsTranslated(
      state,
      {
        payload: { id, langId, isTranslated },
      }: PayloadAction<{
        id: string;
        langId: string;
        isTranslated: boolean;
      }>,
    ) {
      state[id].langs = state[id].langs.map((current) => {
        if (String(current.id) === String(langId)) {
          return { ...current, isTranslated };
        }
        return current;
      });
    },
    markIsTemporalyTranslated(
      state,
      {
        payload: { id, langId, isTemporalyTranslated },
      }: PayloadAction<{
        id: string;
        langId: string;
        isTemporalyTranslated: boolean;
      }>,
    ) {
      state[id].langs = state[id].langs.map((current) => {
        if (String(current.id) === String(langId)) {
          return { ...current, isTemporalyTranslated };
        }
        return current;
      });
    },
    setCurrentValue(
      state,
      {
        payload: { id, langId, currentValue },
      }: PayloadAction<{
        id: string;
        langId: string;
        currentValue: string;
      }>,
    ) {
      state[id].langs = state[id].langs.map((current) => {
        if (String(current.id) === String(langId)) {
          return { ...current, currentValue };
        }
        return current;
      });
    },

    // setSelectedLang(
    //   state,
    //   {
    //     payload: { id, langId },
    //   }: PayloadAction<{
    //     id: string;
    //     langId: string;
    //   }>,
    // ) {
    //   // state.fields[fieldId].langs[langId].selectedLang === langId;
    //   state[id].selectedLanguage = state[id].langs.map((current) => {
    //     if (String(current.id) === String(langId)) {
    //       return String(current.id);
    //     }
    //     return state[id].selectedLanguage;
    //   });
    // },
  },
});

export const translationActions = translationSlice.actions;
export default translationSlice.reducer;
